<template>
  <i
    v-style="{ w, h }"
    aria-hidden="true"
    class="block shrink-0 bg-current forced-colors:bg-[ButtonText]"
    :style="{
      ...(dir && { transform: `rotate(${dirs[dir]}deg)`, transition: 'transform 200ms' }),
      'mask': `url('${url}') ${pos} / contain no-repeat`,
      '-webkit-mask': `url('${url}') ${pos} / contain no-repeat`,
    }"
  />
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'
import type { IconDir, IconName } from '#types/icon'
import type { IconSizes } from '#types/sizes'
import sprite from '#root/assets/icons.svg'

const {
  height,
  name,
  pos = 'left',
  size = { sm: 'sm' },
  src,
  width,
} = defineProps<{
  name?: IconName
  size?: IconSizes | Partial<Responsive<IconSizes>>
  dir?: IconDir
  src?: string
  pos?: string
  height?: string | number | Partial<Responsive>
  width?: string | number | Partial<Responsive>
}>()

const config = useAppConfig().components.vf.icon

if (!name && !src) log.warn('Icon: missing source!')

const dirs = { right: 0, left: 180, up: -90, down: 90 }

const s = computed(() =>
  mapObject(isObject(size) ? size : { sm: size }, (br) => `${pxToRem(config.size[br!])}`)
)
const w = computed(() =>
  width
    ? mapObject(isObject(width) ? width : { sm: width }, (val) => `${pxToRem(+val!)}`)
    : s.value
)
const h = computed(() =>
  height
    ? mapObject(isObject(height) ? height : { sm: height }, (val) => `${pxToRem(+val!)}`)
    : s.value
)

const url = computed(() => src || `${sprite}#${name}`)
</script>
